
// Re-export from refactored modules
export { getLocalAgents } from "./agents/localAgentService";
export { getAgents, getAgentById, getDefaultAgent } from "./agents/combinedAgentService";

// Import for agentService object
import { getLocalAgents } from "./agents/localAgentService";
import { getAgents, getAgentById, getDefaultAgent } from "./agents/combinedAgentService";

// Create agentService object for export
export const agentService = {
  getAllAgents: getAgents,
  getAgentById,
  getDefaultAgent,
  getLocalAgents
};
